import { useContext } from 'react';
import { createContext } from 'react';

import { SearchResultLayoutProps } from '../@types/SearchResultLayoutProps';

export const SearchResultLayoutContext = createContext<SearchResultLayoutProps>({} as SearchResultLayoutProps);

SearchResultLayoutContext.displayName = 'SearchResultLayout';

const SearchResultLayoutProvider = (props: SearchResultLayoutProps) => (
	<SearchResultLayoutContext.Provider value={props}>{props.children}</SearchResultLayoutContext.Provider>
);

export const useSearchResultLayout = () => {
	const context = useContext(SearchResultLayoutContext);

	return context;
};

export default SearchResultLayoutProvider;
